import { useEffect, useState } from 'react'

import NotFound from '../NotFound/NotFound'

import CustomMonacoEditor from './CustomMonacoEditor/CustomMonacoEditor'
import MonacoPageHeader from './MonacoPageHeader/MonacoPageHeader'

import styles from './monaco-section.module.scss'

export interface INavigation {
    _id: string
    name: string
}

interface IMonacoSectionProps {
    title?: string
    navigation?: INavigation[]
    currentNavigationOption?: INavigation
    value: string
    handleSave: (data: string) => Promise<void>
    children?: React.ReactNode
    rawData: string
    handleSelect?: (value: string) => void
    hideSaved?: boolean
    error?: string
}

function MonacoSection(props: IMonacoSectionProps) {
    const {
        title,
        navigation,
        currentNavigationOption,
        value,
        handleSave,
        children,
        rawData,
        handleSelect,
        hideSaved,
        error,
    } = props

    const [monacoData, setMonacoData] = useState(value)
    const [isThemeDark, setIsThemeDark] = useState(true)

    useEffect(() => {
        setMonacoData(value)
    }, [value])

    const handleEditorChange = (value: string | undefined) => {
        value && setMonacoData(value)
    }

    return (
        <section className={styles.monacoSection}>
            <MonacoPageHeader
                title={title}
                navigation={navigation}
                currentNavigationOption={currentNavigationOption}
                handleSave={handleSave}
                value={monacoData}
                isThemeDark={isThemeDark}
                setIsThemeDark={setIsThemeDark}
                rawData={rawData}
                handleSelect={handleSelect}
                hideSaved={hideSaved}
            >
                {children}
            </MonacoPageHeader>
            {error ? (
                <NotFound title={error} />
            ) : (
                <CustomMonacoEditor
                    value={monacoData}
                    handleEditorChange={handleEditorChange}
                    isThemeDark={isThemeDark}
                />
            )}
        </section>
    )
}

export default MonacoSection
